import React from "react";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Stack, Typography, useTheme, alpha } from "@mui/material";

import DeleteConfirmation from "src/shell/components/DeleteConfirmation";
import { getCardStyles, sectionLabelSx } from "src/shell/styles/themeUtils";

interface DangerZoneProps {
  resourceName?: string;
}

const DangerZone: React.FC<DangerZoneProps> = ({ resourceName }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...getCardStyles(theme),
        p: 2,
        borderLeft: `4px solid ${theme.palette.error.main}`,
        bgcolor: alpha(theme.palette.error.main, 0.04),
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2.5 }}>
        <WarningAmberIcon sx={{ fontSize: 18, color: "error.main" }} />
        <Typography
          variant="subtitle2"
          sx={{ ...sectionLabelSx, color: "error.main" }}
        >
          Danger Zone
        </Typography>
      </Stack>
      <DeleteConfirmation
        header="Delete Organization"
        onDelete={() => {}}
        resourceName={resourceName || ""}
        description="This action cannot be undone. This will permanently delete the organization and all associated projects."
      />
    </Box>
  );
};

export default DangerZone;
